// DS: i3.26
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const AddCircle: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="24"
      height="24"
      viewBox="-293 385 24 24"
    >
      <circle
        cx="-281"
        cy="397"
        r="8.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M-280.2,397.8v3.3h-1.7v-3.3h-3.3v-1.7h3.3v-3.3h1.7v3.3h3.3v1.7H-280.2z"
        fill="currentColor"
      />
    </svg>
  </IconWrap>
);
AddCircle.displayName = 'AddCircle';

export default AddCircle;
